import { Injectable, OnInit } from '@angular/core';
import { ApiClient } from '../api-client/api-client';
import { Observable } from 'rxjs';
import { Lottery } from '../../model/interfaces/lottery';
import { LotteryRequest } from '../../model/api/api-request/lottery-request';
import { LotterySaleStopRequest } from 'src/app/model/api/api-request/lottery-sale-stop-request';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ClassActuality } from 'src/app/model/enums/class-actuality';

@Injectable()
export class LotteryRepository implements OnInit
{
    public apiClient: ApiClient;

    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
    }

    public ngOnInit(): void
    {
    }

    public getLotteriesByActuality(actuality?: number): Observable<ReadonlyArray<Lottery>>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new LotteryRequest(actuality, webapiBasepath);
        return this.apiClient.get(request);
    }

    public getSaleStop(saleActuality?: ClassActuality): Observable<any>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new LotterySaleStopRequest(webapiBasepath, saleActuality);
        return this.apiClient.get(request);
    }
}


